export default function Footer() {
  const footerLinks = [
    {
      title: '内容导航',
      links: [
        { label: '暗网动态追踪', href: '#updates' },
        { label: '深度解读', href: '#cards' },
        { label: '暗网影像', href: '#media' },
        { label: '焦点专题', href: '#carousel' },
        { label: '专题索引', href: '#index' },
        { label: '热度榜单', href: '#ranking' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: 'APP下载', href: '#app' },
        { label: '常见问答', href: '#faq' },
        { label: '平台特色', href: '#features' },
      ],
    },
    {
      title: '合作伙伴',
      links: [],
    },
  ];

  return (
    <footer id="footer" className="bg-background-950 text-background-300 pt-14 md:pt-16 pb-8">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50 mb-3 block">
              51暗网
            </span>
            <p className="text-sm text-background-400 leading-relaxed">
              暗网新闻与黑市动态前沿追踪平台。提供暗网黑市、犯罪事件、安全政策的最新动态与深度解读，同时聚合吃瓜爆料内容，帮助你掌握暗网世界的关键脉搏。
            </p>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                {col.title}
              </h4>
              {col.title === '合作伙伴' ? (
                <p className="text-sm text-background-500 leading-relaxed">
                  合作伙伴信息敬请期待
                </p>
              ) : (
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => {
                          e.preventDefault();
                          const id = link.href.replace('#', '');
                          document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2023-2026 51暗网. 本站内容仅供网络安全资讯参考，不提供任何暗网访问服务。
          </p>
          <div className="flex items-center gap-4 text-background-500 text-xs">
            <span className="cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
            <span className="cursor-pointer hover:text-background-300 transition-colors">内容准则</span>
          </div>
        </div>
      </div>
    </footer>
  );
}